require('./categories-new-container.scss')

module.exports = {
  template: require('./categories-new-container.pug')()
  controller: require('./categories-new-container.ctrl')
}
